var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCo2Avoid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8785_49321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.30699 5.61212L5.52302 7.90924C5.69036 8.02877 5.77404 8.08854 5.86161 8.10231C5.93866 8.11442 6.01758 8.10221 6.08736 8.06737C6.16668 8.02778 6.22837 7.94552 6.35176 7.781L7.03134 6.87489C7.06623 6.82836 7.08367 6.8051 7.10418 6.78503C7.12239 6.76722 7.14236 6.7513 7.1638 6.73753C7.18794 6.72203 7.21451 6.71022 7.26765 6.6866L10.1691 5.39707C10.2894 5.34361 10.3495 5.31688 10.3949 5.27514C10.435 5.23822 10.4665 5.193 10.4874 5.14263C10.511 5.08568 10.5153 5.02002 10.5241 4.88869L10.7365 1.70205M10.125 10.125L12.087 10.9659C12.3146 11.0634 12.4285 11.1122 12.4888 11.1932C12.5417 11.2643 12.5677 11.3518 12.5622 11.4403C12.556 11.5411 12.4873 11.6441 12.3499 11.8502L11.4281 13.2328C11.363 13.3305 11.3304 13.3794 11.2874 13.4147C11.2493 13.446 11.2054 13.4695 11.1583 13.4838C11.105 13.5 11.0463 13.5 10.9289 13.5H9.43246C9.27695 13.5 9.19919 13.5 9.13303 13.474C9.07461 13.451 9.02289 13.4137 8.98262 13.3656C8.93701 13.311 8.91242 13.2373 8.86325 13.0897L8.32859 11.4858C8.29959 11.3988 8.28508 11.3553 8.28127 11.311C8.27788 11.2718 8.28069 11.2323 8.28958 11.194C8.29962 11.1508 8.32013 11.1097 8.36115 11.0277L8.76728 10.2154C8.8498 10.0504 8.89106 9.96789 8.95461 9.91666C9.01061 9.87151 9.07842 9.84342 9.14994 9.83575C9.23111 9.82704 9.31863 9.85621 9.49367 9.91456L10.125 10.125ZM16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8785_49321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2Avoid);
export default __webpack_public_path__ + "static/media/co2-avoid.0fb8cecb7c9d3a312d089821ba6172f8.svg";
export { ForwardRef as ReactComponent };